<template>
  <div>
    <div class="d-flex align-items-center flex-wrap">
      <div class="p-1 m-1 d-flex" style="background: #EEEEEE"   v-for="tag in tagArray" :key="tag.id">
        <div style="font-weight: 300">{{ getCleanedTagType(tag.type) }}</div>:&nbsp;<div>{{ tag.name }}</div>
        <div class="pl-2">
          <i @click="removeTagFromEntity(tag)" class="fas fa-trash" style="font-size: 0.8em; cursor: pointer"/>
        </div>
      </div>
      <i class="fas fa-plus" style="cursor: pointer" @click="showTagAdder = !showTagAdder"></i>
    </div>
    <div>
      <b-modal v-model="showNewTagModal" hide-header hide-footer :id="'modal' + this.id">
        <div class="p-4" style="background: #FFFFFF; color: #000000">
          <div class="text-center" v-if="newTagErrorMessage">
            {{ newTagErrorMessage }}
          </div>
          <div style="font-weight: 300">
            Tag Name
          </div>
          <div class="p-1">
            <b-form-input class="" size="sm" id="tagPicker" v-model="searchedTagName" type="text" placeholder="Enter Tag" autocomplete="off"/>
          </div>
          <div class="p-1">
            <div style="font-weight: 300">
              Tag Type
            </div>
            <b-form-select size="sm" :options="tagTypes" v-model="searchedTagType"/>
          </div>
          <div class="d-flex justify-content-center">
            <button class="btn btn-sm btn-dark mt-4" @click="addNewTag">ADD TAG</button>
          </div>
        </div>
      </b-modal>
    </div>
    <div class="p-2" v-if="showTagAdder" style="border: 1px solid #EEEEEE">
      <div class="d-flex">
        <div class="flex-fill">
          <b-form-input size="sm" id="tagPicker" v-model="searchedTagName" type="text" placeholder="Enter Tag" autocomplete="off" @input="(e) => searchTags(e)"/>
        </div>
        <div class="d-flex pl-1">
          <button @click="showNewTagModal = !showNewTagModal" class="btn btn-danger btn-sm mx-1" style="color: #FFFFFF">ADD NEW TAG</button>
          <button class="btn btn-dark btn-sm" @click="showTagAdder = false">CLOSE TAG ADDER</button>
        </div>
      </div>
      <transition name="fade">
        <div class="d-flex flex-wrap">
          <div v-for="possibleTag in getTagsNotAlreadyConnectedToOrganization" :key="possibleTag.id">
            <div class="p-1 m-1 d-flex" style="background: #EEEEEE">
              <div class="d-flex align-items-center">
                <span class="p-1" style="font-weight: 300">{{ getCleanedTagType(possibleTag.type) }}:</span>
                {{ possibleTag.name }}
                <div class="pl-2">
                  <i @click="addTagToEntity(possibleTag)" class="fas fa-plus" style="font-size: 0.8em; cursor: pointer"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import MedicalAlleyStartsAPIV3 from '../../api/medicalAlleyStartsV3'
import TagMethods from './TagMethods'

export default {
  name: '',
  props: ['id', 'tagArray'],
  data: function () {
    return {
      showTagAdder: false,
      possibleTags: [],
      //  ADDING NEW TAGS
      showNewTagModal: false,
      newTagErrorMessage: null,
      searchedTagName: '',
      searchedTagType: null,
      tagTypes: [
        {
          text: 'INVESTOR TYPE',
          value: 'investor_tag'
        },
        {
          text: 'INVESTOR TARGET AREA',
          value: 'investor_target_area'
        },
        {
          text: 'INVESTOR TARGET SIZE',
          value: 'investor_target_size'
        }
      ]
    }
  },
  computed: {
    tagIDsInList () {
      let tagIDs = []
      this.tagArray.forEach((x) => {
        tagIDs.push(x.id)
      })
      return tagIDs
    },
    getTagsNotAlreadyConnectedToOrganization () {
      let toReturn = []
      this.possibleTags.forEach((x) => {
        if (this.tagIDsInList.indexOf(x.id) === -1) {
          toReturn.push(x)
        }
      })
      return toReturn
    }
  },
  methods: {
    searchTags (searchedTagName) {
      if (searchedTagName < 3) {
        this.possibleTags = []
        return
      }
      setTimeout(() => {
        this.isTyping = false
        this.isSearching = true
        MedicalAlleyStartsAPIV3.getTags({name: searchedTagName}).then(
          response => {
            this.possibleTags = response.data.data
            this.isSearching = false
          }
        )
      }, 500)
      this.isTyping = true
    },
    getCleanedTagType (type) {
      return TagMethods.getCleanedTagType(type)
    },
    addTagToEntity (tag) {
      this.$store.commit('setIsLoading', true)
      MedicalAlleyStartsAPIV3.addTagToEntity(this.id, tag.id).then(
        response => {
          if (response.data.success) {
            this.tagArray.push(tag)
            this.searchedTagName = ''
          }
          this.$store.commit('setIsLoading', false)
        }
      )
    },
    removeTagFromEntity (tag) {
      this.$store.commit('setIsLoading', true)
      MedicalAlleyStartsAPIV3.removeTagFromEntity(this.id, tag.id).then(
        response => {
          if (response.data.success) {
            for (let i = 0; i < this.tagArray.length; i++) {
              if (this.tagArray[i].id === tag.id) {
                this.tagArray.splice(i, 1)
              }
            }
            this.searchedTagName = ''
          }
          this.$store.commit('setIsLoading', false)
        }
      )
    },
    addNewTag() {
      this.newTagErrorMessage = null

      // ERROR CHECK
      if (this.searchedTagType === null) {
        this.newTagErrorMessage = "You must enter a tag type."
        return
      }
      if (this.searchedTagName === '') {
        this.newTagErrorMessage = "You must enter a tag name."
        return
      }

      this.$store.commit('setIsLoading', true)
      MedicalAlleyStartsAPIV3.addNewTag(this.searchedTagName, this.searchedTagType).then(
        response => {
          if (response.data.success) {
            const newTag = response.data.data

            //  Reset Variables.
            this.showNewTagModal = false
            this.searchedTagName = ''
            this.searchedTagType = null

            this.showTagAdder = false

            //  Add to new org
            this.addTagToEntity(newTag)
          }
          this.$store.commit('setIsLoading', false)
        }
      )
    }
  },
  created () {
    this.showTagAdder = false
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/medicalAlleyStarts/ListOfTags.vue